"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "auronzo-di-cadore": {
    "69d5f159": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cella": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "auronzo-di-cadore"
    }],
    "23a7cd5f": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "giralba": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "auronzo-di-cadore"
    }],
    "e55e5bb4": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "skipSearch": false
    }],
    "ligonto": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72692615": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "skipSearch": false
    }],
    "pause": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd561aaa": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "reane": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "auronzo-di-cadore"
    }],
    "20e9c8da": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "skipSearch": false
    }],
    "rizio": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b63475b8": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "a83db576",
      "slug": "auronzo-di-cadore",
      "name": "Auronzo di Cadore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13327a85": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villapiccola": [{
      "hkey": "f9feac33",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "auronzo-di-cadore"
    }]
  }
};
exports["default"] = _default;